import { z } from 'zod'
import { paginationQuerySchema } from './api-response.ts'
import { decimalSchema, uuidSchema } from './common.ts'
import { productionOrderItemReadinessSchema } from './production-supply.ts'

export const productionMaterialRequestKindSchema = z.enum(['issue', 'purchase'])
export const createProductionMaterialRequestSchema = z.object({
  kind: productionMaterialRequestKindSchema,
  materialId: uuidSchema.optional(),
  note: z.string().trim().max(1000).optional(),
})
export const productionMaterialRequestQuerySchema = paginationQuerySchema.extend({
  limit: z.coerce.number().int().positive().max(50).default(50),
  kind: productionMaterialRequestKindSchema.optional(),
  state: z.enum(['open', 'completed', 'cancelled']).default('open'),
})
export const fulfillProductionPurchaseSchema = z.object({
  supplierId: uuidSchema,
  locationId: uuidSchema,
  expectedAt: z.iso.date().nullable(),
})
export const productionMaterialRequestSchema = z.object({
  id: uuidSchema,
  stageId: uuidSchema,
  orderId: uuidSchema,
  orderNumber: z.string(),
  itemId: uuidSchema.nullable(),
  itemName: z.string(),
  planId: uuidSchema,
  kind: productionMaterialRequestKindSchema,
  materialId: uuidSchema.nullable(),
  materialName: z.string().nullable(),
  quantity: decimalSchema.nullable(),
  unit: z.string().nullable(),
  note: z.string().nullable(),
  state: z.enum(['open', 'completed', 'cancelled']),
  requestedByName: z.string(),
  createdAt: z.string(),
  fulfilledAt: z.string().nullable(),
  supplyId: uuidSchema.nullable(),
  supplyStatus: z.string().nullable(),
  expectedAt: z.string().nullable(),
  supplierId: uuidSchema.nullable(),
  supplierName: z.string().nullable(),
  paymentRequestId: uuidSchema.nullable(),
  paymentStatus: z.string().nullable(),
})
export const productionTaskMaterialsSchema = z.object({
  item: productionOrderItemReadinessSchema.nullable(),
  requests: z.array(productionMaterialRequestSchema),
  locations: z.array(
    z.object({
      materialId: uuidSchema,
      warehouseName: z.string(),
      locationName: z.string(),
      reserved: decimalSchema,
    }),
  ),
})
export type ProductionMaterialRequest = z.infer<typeof productionMaterialRequestSchema>
export type ProductionTaskMaterials = z.infer<typeof productionTaskMaterialsSchema>
export type CreateProductionMaterialRequest = z.infer<typeof createProductionMaterialRequestSchema>
export type FulfillProductionPurchase = z.infer<typeof fulfillProductionPurchaseSchema>
